import React from 'react';
import styled from 'styled-components';
import ImageButton from './ImageButton';

export default function Question(props) {

  const checkAnswer = (guess) => {
    let correctAnswer = props.question.person;
    if (guess === correctAnswer) {
      props.right();
    } else {
      // eslint-disable-next-line no-undef
      mixpanel.track("Wrong Answer",
        {
          question: props.question.questionText,
          person: `${guess.firstName} ${guess.lastName}`
        });
      props.wrong();
    }
  };


  const getPeople = () => {
    return props.question.people.map((person, idx) => {
      return <Wrapper key={idx}>
        <ImageButton
          onClick={() => checkAnswer(person)}
          alt={'Need photo of ' + person.firstName + ' ' + person.lastName}
          src={person.image}>
        </ImageButton>
      </Wrapper>
    });
  }

  return <div>
    <h2>{props.question.questionText}</h2>
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
      {getPeople()}
    </div>
  </div>;
}

const Wrapper = styled.div`
  padding: 0 20px;

  @media (max-width:480px)  { /* smartphones, Android phones, landscape iPhone */ 
    padding: 0 5px;
  }
`;